<template>
  <div class="index">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col-sm-12">
                <h3 class="page-title">Welcome {{ memberSessionArr.name }}!</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Dashboard Instagram</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <div class="row">
            <div class="col-md-6">
              <last-post />
            </div>
            <div class="col-md-6">
              <post-terjadwal />
            </div>
          </div>
          <!-- Statistics Widget -->
          <!-- <graph-sum-license /> -->

          <!-- /Statistics Widget -->
        </div>
        <!-- /Page Content -->
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>
<script>
// import GraphSumLicense from "./components/graphSumLicense.vue";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import TotalScrapeMarketplace from "./components/totalScrapeMarketplace";
import TotalScrapeStatus from "./components/totalScrapeStatus";
import LastPost from "./components/lastPost";
import PostTerjadwal from "./components/postTerjadwal";
import { nFormatter } from "@/utils/helper";
import Vue from "vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    // GraphSumLicense
    TotalScrapeMarketplace,
    TotalScrapeStatus,
    LastPost,
    PostTerjadwal
  },
  computed: {
    memberSessionArr() {
      return this.$store.state.login.memberSession;
    },
    numLicenseTotal() {
      return this.$store.state.member.numLicenseTotal;
    },
    numAgentTotal() {
      return this.$store.state.member.numAgentTotal;
    },
    numMessageTotal() {
      return this.$store.state.member.numMessageTotal;
    },
    numActiveVoucherTotal() {
      return this.$store.state.member.numActiveVoucherTotal;
    }
  },
  created() {
    // this.getLicenseTotal();
    // this.getAgentTotal();
    // this.getMessageTotal();
    // this.$store.dispatch("member/getActiveVoucherTotal");
  },
  mounted() {},
  methods: {
    nFormatter(value) {
      return nFormatter(value);
    },
    getMessageTotal() {
      let params = {};
      params = {
        provider: "whatsapp"
      };
      this.$store.dispatch("member/getMessageTotal", params);
    },
    getLicenseTotal() {
      this.$store.dispatch("member/getLicenseTotal");
    },
    getAgentTotal() {
      this.$store.dispatch("member/getAgentTotal");
    }
  },
  name: "index"
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/instagramDashboard.vue